<template>
  <div class="modal fade" id="modify_room" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div class="block-header bg-info">
            <h3 class="block-title"><i class="fa fa-cannabis"></i> Add Room</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close" @click.prevent="clearData()">
              <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{errorMsg}}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <div class="form-group required">
              <label class="control-label">Room Name</label>
              <input type="text" v-model="name" name="room_name" v-validate="'required'" data-vv-as="Room Name" class="form-control form-control-alt" placeholder="Enter room name">
              <p v-if="errors.has('room_name')" class="errorMsg">{{ errors.first('room_name') }}</p>
            </div>
          </div>
          <div class="block-content block-content-full text-right border-top button-loader">
            <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData()">Close</button>
            <button type="button" class="btn btn-sm btn-primary" @click="modifyRoom()" :bind:disabled="showModalLoader">
              <div><i class="fa fa-save mr-1"></i><span>Save</span></div>
              <span class="modal-loader" v-if="showModalLoader">
                <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { VueSpinners } from '@saeris/vue-spinners';
import { HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';

Vue.use(VeeValidate, VueSpinners);
export default {
  name: 'ModifyRoom',
  data() {
    return {
      id: 0,
      name: '',
      showModalLoader: false,
      errorMsg: ''
    };
  },
  components: {
    HashLoader
  },
  methods: {
    clearData() {
      this.id = 0;
      this.name = '';
      this.errorMsg = '';
      this.$validator.reset();
    },
    modifyRoom() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (valid) {
          vm.showModalLoader = true;
          vm.errorMsg = '';
          let action = this.id ? 'update' : 'create';
          helper.sendPostRequest(
            '/rooms/' + action,
            {'Name': vm.name, 'Id': vm.id}
          ).then((data) => {
            vm.showModalLoader = false;
            if (data.status === 'success') {
              vm.$emit('loadRooms', true);
              jQuery('#modify_room').modal('hide');
              vm.$emit('showSuccessMsg', data.message);
              vm.clearData();
            } else {
              vm.errorMsg = data.message;
            }
          });
        }
      });
    },
    loadRoom(room) {
      this.id = room.Id;
      this.name = room.Name;
    }
  }
};
</script>


// WEBPACK FOOTER //
// source/components/modals/ModifyRoom.vue